import React from "react";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";
import Avatar from "@mui/joy/Avatar";

export default function MensajeChatAmigo({ foto_amigo, mensaje_chat_amigo }) {
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          justifyContent: "left",
          marginBottom: "1rem",
        }}
      >
        <Avatar src={`${linkimagen}/uploads/` + foto_amigo} />
        <Box
          sx={{
            backgroundColor: "#f0f4f8",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            maxWidth: "15rem",
            fontSize: "0.875rem",
            color: "#333",
            borderTopLeftRadius: "0px",
          }}
        >
          {" "}
          <Typography level="body-sm" sx={{ color: "black" }}>
            {mensaje_chat_amigo ? mensaje_chat_amigo : null}
          </Typography>
        </Box>
      </Box>
    </div>
  );
}
